import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
var _ref = /*#__PURE__*/React.createElement(Icon, {
  name: "closeSmall",
  size: "large"
});
export default /*#__PURE__*/React.memo(props => {
  const onClick = e => {
    e.stopPropagation();
    props.selectProps.onChange(null, {
      action: 'clear'
    });
  };
  props.innerProps.onMouseDown = onClick;
  let icon = _ref;
  if (props?.selectProps?.clearIcon) {
    icon = props?.selectProps?.clearIcon;
  }
  return components.ClearIndicator && /*#__PURE__*/React.createElement(components.ClearIndicator, props, icon);
});